import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="February 26, 2026">
      <p>
        These Terms of Service ("Terms") govern your access to and use of <strong>Facade Lighting Studio</strong> (the
        "Service"). By using the Service you agree to these Terms.
      </p>

      <h2>1. Eligibility and account</h2>
      <p>
        You must be at least 18 years old (or the age of majority in your jurisdiction) to create an account. You are
        responsible for keeping your login credentials secure and for all activity under your account.
      </p>

      <h2>2. Acceptable use</h2>
      <p>You agree NOT to:</p>
      <ul>
        <li>Upload images you do not own or have permission to modify.</li>
        <li>Use the Service for unlawful, defamatory, or harmful purposes.</li>
        <li>Reverse-engineer, scrape, or attempt to copy the Service.</li>
        <li>Resell access, share paid accounts, or redistribute exported AI-enhanced images outside your own client work.</li>
        <li>Interfere with the Service's operation or attempt to bypass usage limits, watermarks, or paid feature gates.</li>
      </ul>

      <h2>3. Subscriptions and credits</h2>
      <ul>
        <li><strong>Pro Monthly / Pro Yearly</strong> — one-time charge that grants Pro features for 30 or 365 days respectively.</li>
        <li><strong>AI credit packs</strong> — one-time payment for a fixed number of AI Finalize calls. Credits do not expire.</li>
        <li>
          Pricing is displayed at <a href="/pricing">/pricing</a>. We reserve the right to change pricing for new purchases at any
          time, but existing paid periods are honored at the price you originally paid.
        </li>
      </ul>

      <h2>4. Payments</h2>
      <p>
        Payments are processed by Stripe (international) and Razorpay (India). By making a payment you also agree to the
        respective payment processor's terms. All amounts are charged in the currency displayed at checkout, plus any
        applicable taxes.
      </p>

      <h2>5. Refunds</h2>
      <p>
        Our refund policy is described in detail at <a href="/refund">/refund</a>. In summary: subscriptions may be refunded
        within 7 days of purchase if no AI Finalize calls have been used. AI credit packs are non-refundable once any
        credits have been spent.
      </p>

      <h2>6. AI Enhance content</h2>
      <p>
        When you use the AI Finalize feature, your image is transmitted to Google's Gemini API to generate the enhanced
        output. You retain ownership of your input images and the AI-generated outputs (subject to Google's terms for AI
        outputs). We do not claim copyright over your projects.
      </p>

      <h2>7. Free tier and watermarks</h2>
      <p>
        The free tier includes a watermark on exported images. Removing or obscuring the watermark from a free-tier export
        and presenting the image as original work is a violation of these Terms.
      </p>

      <h2>8. Intellectual property</h2>
      <p>
        The Service, its source code, design, branding, and trademarks are owned by us. Your use of the Service does not
        grant you any rights to our intellectual property except the limited license to use the Service as intended.
      </p>

      <h2>9. Termination</h2>
      <p>
        You may delete your account at any time by emailing <a href="mailto:xpertzankur@gmail.com">xpertzankur@gmail.com</a>.
        We may suspend or terminate accounts that violate these Terms, with or without notice for severe violations.
      </p>

      <h2>10. Disclaimers</h2>
      <p>
        The Service is provided "as is" without warranties of any kind. We do not warrant that the Service will be
        uninterrupted, error-free, or fit for any particular purpose. AI-generated outputs may contain artifacts and should
        be reviewed before use in professional deliverables.
      </p>

      <h2>11. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, our total liability for any claim arising out of or relating to the Service
        is limited to the amount you paid us in the twelve months preceding the claim.
      </p>

      <h2>12. Governing law</h2>
      <p>
        These Terms are governed by the laws of India. Disputes will be subject to the exclusive jurisdiction of courts in
        India.
      </p>

      <h2>13. Changes</h2>
      <p>
        We may update these Terms. Material changes will be communicated via email or in-app notice. Continued use after
        changes take effect constitutes acceptance.
      </p>

      <h2>14. Contact</h2>
      <p>
        Questions about these Terms? Email <a href="mailto:xpertzankur@gmail.com">xpertzankur@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
